/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
'use strict';

var EventEmitter = require('eventemitter3');

module.exports = {
    connections: {},
    EE: new EventEmitter(),
    enableResizeInfo: false,
    enableScrollInfo: false,
    listeners: {},
    removers: []
};



//////////////////
// WEBPACK FOOTER
// ./~/subscribe-ui-event/dist/globalVars.js
// module id = ./node_modules/subscribe-ui-event/dist/globalVars.js
// module chunks = 168707334958949